import home from './home'
import login from './login'
import chat from './chat'
import course from './course'
import channels from './channels'
import file from './file'
import user from './user'
import classSearch from './calss-search'

export default {
  home,
  login,
  chat,
  course,
  channels,
  file,
  user,
  classSearch,
}
